// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1Dibu","tab":"Tabs_tab__iGoGE","tabActive":"Tabs_tabActive__3Uwdr"};